// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
export var TagCategory;
(function (TagCategory) {
    TagCategory["UNKNOWN"] = "UNKNOWN";
    TagCategory["PAYMENTS"] = "PAYMENTS";
    TagCategory["MEDICAL_HISTORY"] = "MEDICAL_HISTORY";
})(TagCategory || (TagCategory = {}));
export var TagCategory_index;
(function (TagCategory_index) {
    TagCategory_index[TagCategory_index["UNKNOWN"] = 0] = "UNKNOWN";
    TagCategory_index[TagCategory_index["PAYMENTS"] = 1] = "PAYMENTS";
    TagCategory_index[TagCategory_index["MEDICAL_HISTORY"] = 2] = "MEDICAL_HISTORY";
})(TagCategory_index || (TagCategory_index = {}));
export var SubmissionListSortByField;
(function (SubmissionListSortByField) {
    SubmissionListSortByField["SUBMISSION_UNKNOWN"] = "SUBMISSION_UNKNOWN";
    SubmissionListSortByField["SUBMISSION_CREATED_AT"] = "SUBMISSION_CREATED_AT";
    SubmissionListSortByField["SUBMISSION_SUBMITTED_AT"] = "SUBMISSION_SUBMITTED_AT";
    SubmissionListSortByField["SUBMISSION_ARCHIVED_AT"] = "SUBMISSION_ARCHIVED_AT";
})(SubmissionListSortByField || (SubmissionListSortByField = {}));
export var SubmissionListSortByField_index;
(function (SubmissionListSortByField_index) {
    SubmissionListSortByField_index[SubmissionListSortByField_index["SUBMISSION_UNKNOWN"] = 0] = "SUBMISSION_UNKNOWN";
    SubmissionListSortByField_index[SubmissionListSortByField_index["SUBMISSION_CREATED_AT"] = 1] = "SUBMISSION_CREATED_AT";
    SubmissionListSortByField_index[SubmissionListSortByField_index["SUBMISSION_SUBMITTED_AT"] = 2] = "SUBMISSION_SUBMITTED_AT";
    SubmissionListSortByField_index[SubmissionListSortByField_index["SUBMISSION_ARCHIVED_AT"] = 3] = "SUBMISSION_ARCHIVED_AT";
})(SubmissionListSortByField_index || (SubmissionListSortByField_index = {}));
export var Order;
(function (Order) {
    Order["ORDER_UNKNOWN"] = "ORDER_UNKNOWN";
    Order["ASC"] = "ASC";
    Order["DESC"] = "DESC";
})(Order || (Order = {}));
export var Order_index;
(function (Order_index) {
    Order_index[Order_index["ORDER_UNKNOWN"] = 0] = "ORDER_UNKNOWN";
    Order_index[Order_index["ASC"] = 1] = "ASC";
    Order_index[Order_index["DESC"] = 2] = "DESC";
})(Order_index || (Order_index = {}));
export var SubmissionCategory;
(function (SubmissionCategory) {
    SubmissionCategory["SUBMISSION_CATEGORY_UNKNOWN"] = "SUBMISSION_CATEGORY_UNKNOWN";
    SubmissionCategory["SUBMISSION_CATEGORY_COMPLETED"] = "SUBMISSION_CATEGORY_COMPLETED";
    SubmissionCategory["SUBMISSION_CATEGORY_RETRY_SYNC"] = "SUBMISSION_CATEGORY_RETRY_SYNC";
    SubmissionCategory["SUBMISSION_CATEGORY_NEEDS_REVIEW"] = "SUBMISSION_CATEGORY_NEEDS_REVIEW";
    SubmissionCategory["SUBMISSION_CATEGORY_SYNC_MANUALLY"] = "SUBMISSION_CATEGORY_SYNC_MANUALLY";
    SubmissionCategory["SUBMISSION_CATEGORY_REVIEWED"] = "SUBMISSION_CATEGORY_REVIEWED";
})(SubmissionCategory || (SubmissionCategory = {}));
export var SubmissionCategory_index;
(function (SubmissionCategory_index) {
    SubmissionCategory_index[SubmissionCategory_index["SUBMISSION_CATEGORY_UNKNOWN"] = 0] = "SUBMISSION_CATEGORY_UNKNOWN";
    SubmissionCategory_index[SubmissionCategory_index["SUBMISSION_CATEGORY_COMPLETED"] = 1] = "SUBMISSION_CATEGORY_COMPLETED";
    SubmissionCategory_index[SubmissionCategory_index["SUBMISSION_CATEGORY_RETRY_SYNC"] = 2] = "SUBMISSION_CATEGORY_RETRY_SYNC";
    SubmissionCategory_index[SubmissionCategory_index["SUBMISSION_CATEGORY_NEEDS_REVIEW"] = 3] = "SUBMISSION_CATEGORY_NEEDS_REVIEW";
    SubmissionCategory_index[SubmissionCategory_index["SUBMISSION_CATEGORY_SYNC_MANUALLY"] = 4] = "SUBMISSION_CATEGORY_SYNC_MANUALLY";
    SubmissionCategory_index[SubmissionCategory_index["SUBMISSION_CATEGORY_REVIEWED"] = 5] = "SUBMISSION_CATEGORY_REVIEWED";
})(SubmissionCategory_index || (SubmissionCategory_index = {}));
export var SubmissionReviewStatus;
(function (SubmissionReviewStatus) {
    SubmissionReviewStatus["SUBMISSION_REVIEW_UNKNOWN"] = "SUBMISSION_REVIEW_UNKNOWN";
    SubmissionReviewStatus["SUBMISSION_REVIEW_PENDING"] = "SUBMISSION_REVIEW_PENDING";
    SubmissionReviewStatus["SUBMISSION_REVIEW_APPROVED"] = "SUBMISSION_REVIEW_APPROVED";
    SubmissionReviewStatus["SUBMISSION_REVIEW_REJECTED"] = "SUBMISSION_REVIEW_REJECTED";
    SubmissionReviewStatus["SUBMISSION_REVIEW_REVIEWED"] = "SUBMISSION_REVIEW_REVIEWED";
})(SubmissionReviewStatus || (SubmissionReviewStatus = {}));
export var SubmissionReviewStatus_index;
(function (SubmissionReviewStatus_index) {
    SubmissionReviewStatus_index[SubmissionReviewStatus_index["SUBMISSION_REVIEW_UNKNOWN"] = 0] = "SUBMISSION_REVIEW_UNKNOWN";
    SubmissionReviewStatus_index[SubmissionReviewStatus_index["SUBMISSION_REVIEW_PENDING"] = 1] = "SUBMISSION_REVIEW_PENDING";
    SubmissionReviewStatus_index[SubmissionReviewStatus_index["SUBMISSION_REVIEW_APPROVED"] = 2] = "SUBMISSION_REVIEW_APPROVED";
    SubmissionReviewStatus_index[SubmissionReviewStatus_index["SUBMISSION_REVIEW_REJECTED"] = 3] = "SUBMISSION_REVIEW_REJECTED";
    SubmissionReviewStatus_index[SubmissionReviewStatus_index["SUBMISSION_REVIEW_REVIEWED"] = 4] = "SUBMISSION_REVIEW_REVIEWED";
})(SubmissionReviewStatus_index || (SubmissionReviewStatus_index = {}));
export var TriState;
(function (TriState) {
    TriState["TRISTATE_UNKNOWN"] = "TRISTATE_UNKNOWN";
    TriState["TRUE"] = "TRUE";
    TriState["FALSE"] = "FALSE";
})(TriState || (TriState = {}));
export var TriState_index;
(function (TriState_index) {
    TriState_index[TriState_index["TRISTATE_UNKNOWN"] = 0] = "TRISTATE_UNKNOWN";
    TriState_index[TriState_index["TRUE"] = 1] = "TRUE";
    TriState_index[TriState_index["FALSE"] = 2] = "FALSE";
})(TriState_index || (TriState_index = {}));
